"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
require("./userInfoApi");
const userInfoEndpointKeys_1 = require("./userInfoEndpointKeys");
const request_1 = __importDefault(require("@hotmart/request"));
class UserInfoService {
}
_a = UserInfoService;
UserInfoService.getProfile = async () => {
    return await (0, request_1.default)(userInfoEndpointKeys_1.UserInfoEndpointKeys.GetUserProfile);
};
UserInfoService.getTypeInfo = async () => {
    return await (0, request_1.default)(userInfoEndpointKeys_1.UserInfoEndpointKeys.GetUserTypeInfo);
};
exports.default = UserInfoService;
